import Vue from 'vue';
import Router from 'vue-router';
import Storage from '@/utils/storage';
import getRoutes from '@/router/routes';
Vue.use(Router);
import { scrollTopWindow } from "@/utils/helper";
const _createRouter = () => new Router({
  mode: "history",
  routes: getRoutes()
});
const router = _createRouter()

router.beforeEach((to, from, next) => {
  const { store } = Vue.prototype;
  scrollTopWindow()
  if(to.name === 'login-token') {
    store.dispatch('login', to.params).then(() => {
      next({
        name: 'homepage'
      });
    });
    return;
  }
  if(store.state.toggle.showSidebar) {
    store.state.toggle.showSidebar = false
  }
  // lets pass
  const isGuest = to.matched.some(
    record => record.meta.guest,
  );
  if(to.name == 'courses.home' && (store.state.toggle.dialogGoogleMap.dialog == true)) {
    store.state.toggle.dialogGoogleMap.closeDialog()
  }
  if (isGuest) return next();

  const loggedIn = Storage.get('token');
  const loggedOut = to.matched.some(
    record => record.meta.loggedOut,
  );

  // console.log(loggedIn, loggedOut, loggedIn && loggedOut)
  // handle authentication
  if (!loggedIn && !loggedOut) {
    return next({
      name: 'login',
      query: {
        redirect: to.fullPath
      },
    });
  } else if (loggedIn && loggedOut) {
    return next({
      name: 'ranking',
    });
  } else {
    next();
  }
});

export function createRouter() {
  return _createRouter()
}

export default router;